import BrandingLogo from './BrandingLogo.component';

export default BrandingLogo;
